/**
 * Licensed Materials - Property of IBM
 * IBM Watson (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

'use strict';

import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import './dotsIndicator.scss';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

@observer
class DotsIndicator extends React.Component {
	@observable.shallow items = [];

	constructor(props) {
		super(props);
		this.items = props.items;
	}
	_onDotClick(options, e) {
		e.preventDefault();
		this.props.onDotClick && this.props.onDotClick(options);
	}

	_renderDot(i){
		const className = classnames({
			'dot-active': (this.props.activeIndex === i)
		});

		var dotOptions = {
			message: 'dots',
			indexClicked: i,
			currentActiveIndex: this.props.activeIndex
		};

		var onClick = this._onDotClick.bind(this, dotOptions);
		return <li key={i} className = { className }>
			<button onClick = {onClick}> {i + 1}</button>
		</li>;
	}
	render() {
		var dotCount = this.props.items ? this.props.items.length : 0;
		if( dotCount <= 1) {
			return null;
		}
		const {
			onMouseEnter,
			onMouseOver,
			onMouseLeave
		} = this.props;
		const mouseEvents = {
			onMouseEnter,
			onMouseOver,
			onMouseLeave
		};
		const dotArray = Array(dotCount + 1).join('0').split('');
		const dots = Array.apply(null, dotArray)
			.map((item, index) => this._renderDot(index));
		return <ul className = 'dots-indicator'  {...mouseEvents} >{dots}</ul>;
	}
}

DotsIndicator.propTypes = {
	items: PropTypes.array.isRequired,
	dotsClass: PropTypes.string,
	onMouseEnter: PropTypes.func,
	onMouseOver: PropTypes.func,
	onMouseLeave: PropTypes.func,
	onDotClick: PropTypes.func,
	activeIndex: PropTypes.number
};

DotsIndicator.defaultProps = {
	activeIndex: 0,
	onDotClick: () => {}
};

export default DotsIndicator;



// WEBPACK FOOTER //
// ./src/js/lib/@waca/vis-recommender/src/js/util/DotsIndicator.js